// extracted by css-extract-rspack-plugin
module.exports =  {"itemAction":"OCRScopeJobItem__itemAction___Kyvv_"};